import type {BuildId} from '../../../../../types'

export enum VcsRootGroup {
  DEPENDENCIES = 'dependencies',
  SETTINGS = 'settings',
}

export type Props = {
  className?: string
  buildId: BuildId
  seqKey?: string
}

export type RequestBuildChangesRevisionsParams = {
  withSettingsRevisions?: boolean
}
